import React from "react";
import { Box } from "@mui/material";
import { useVersions } from "../../services/versions/versions.service";
import { Loading } from "../../components";

const HealthView = () => {
  const { versions, loading } = useVersions();


  if (loading) {
    return <Loading centerAll />;
  }

  return (
    <Box sx={{ p: 2, fontSize: "13px" }}>
      {versions?.map((version) => (
        <pre key={version.name}>
          <code>
            {JSON.stringify(version, null, 2)}
            <br />
          </code>
        </pre>
      ))}
    </Box>
  );
};

export default HealthView;
